import { AssignmentRow } from '@policyvision/contracts';

import { TableCell, TableRow } from '@/common/components/ui/table';

interface AssignmentTableRowsProps {
  headers: string[];
  assignmentRowData: AssignmentRow[];
}

export const AssignmentTableRows = ({
  headers,
  assignmentRowData,
}: AssignmentTableRowsProps) => {
  return assignmentRowData.map((row) => (
    <TableRow key={row.title} className="bg-white even:bg-white">
      <TableCell className="border-r border-warm-gray-200 whitespace-normal">
        {row.title}
      </TableCell>
      {headers.map((header) => (
        <TableCell
          key={header}
          className="border-r border-warm-gray-200 whitespace-normal"
        >
          {row.values[header]}
        </TableCell>
      ))}
    </TableRow>
  ));
};
